import { createContext } from "react";

const Psu_Information = createContext();

export default Psu_Information;
